import { useRef } from 'react';
import { AboutProject } from '../../components/about-project/AboutProject';
import { CommunicationsSection } from '../../components/communications-section/CommunicationsSection';
import { ContactSection } from '../../components/contact-section/ContactSection';
import { FaqSection } from '../../components/faq-section/FaqSection';
import { Hero } from '../../components/hero/Hero';
import { LivingSpace } from '../../components/living-space/LivingSpace';
import { LakeHousesSection } from '../../components/lake-houses-section/LakeHousesSection';
import { LocationSection } from '../../components/location-section/LocationSection';
import { PurchaseSection } from '../../components/purchase-section/PurchaseSection';
import { SettlementCare } from '../../components/settlement-care/SettlementCare';
import { SiteHeader } from '../../components/site-header/SiteHeader';
import { SiteFooter } from '../../components/site-footer/SiteFooter';
import { GenplanSection } from '../../features/genplan/components';
import { useScrollReveal } from '../../lib/useScrollReveal';
import styles from './HomePage.module.scss';

export function HomePage() {
  const pageRef = useRef<HTMLElement>(null);
  useScrollReveal(pageRef);

  return (
    <>
      <main ref={pageRef} className={styles.page}>
        <SiteHeader />
        <Hero />
        <AboutProject />
        <CommunicationsSection />
        <LivingSpace />
        <LocationSection />
        <SettlementCare />
        <GenplanSection />
        <LakeHousesSection />
        <PurchaseSection />
        <FaqSection />
        <ContactSection />
      </main>
      <SiteFooter />
    </>
  );
}
